/**
 * Everyday use cards — optional scroll reveal (skipped when reduced motion is on).
 */
(function () {
  if (window.__eucRevealLoaded) return;
  window.__eucRevealLoaded = true;

  var roots = document.querySelectorAll('[data-euc-root]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.getAttribute('data-euc-animate') !== 'true') return;

    var cards = root.querySelectorAll('.euc-card[data-reveal]');
    if (!cards.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach(function (el) {
        el.classList.add('euc-card--visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (el) {
        el.classList.add('euc-card--visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('euc-card--visible');
          io.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    cards.forEach(function (el) {
      io.observe(el);
    });
  });
})();
